import './NotFoundPage.css'

const NotFoundPage = () => {
  return (
    <div className={'container'}>
      <p style={{ fontSize: 50, color: '#fff' }}>404 🧐</p>
    </div>
  )
}

export default NotFoundPage
